import { render, staticRenderFns } from "./PastDiyoboEvent.vue?vue&type=template&id=2e17e350&scoped=true"
import script from "./PastDiyoboEvent.vue?vue&type=script&lang=js"
export * from "./PastDiyoboEvent.vue?vue&type=script&lang=js"
import style0 from "./PastDiyoboEvent.vue?vue&type=style&index=0&id=2e17e350&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17e350",
  null
  
)

export default component.exports